  function triggerButton() {
    // App ke button ko uski unique class aur data-id se select karo
    const targetButton = document.querySelector('.storeify-quote-btn-trigger-popup[data-id="8240"]');
    
    if (targetButton) {
      targetButton.click(); // App ke button ko programmatically click karo
    } else {
      console.warn('Storeify Quote button not found!');
    }
  }

 // document.querySelectorAll('a[href="#trustshop-review"]').forEach(anchor => {
 //    anchor.addEventListener('click', function (e) {
 //      e.preventDefault(); // stop default jump
 //      const target = document.querySelector('#trustshop-review');
 //      if (target) {
 //        const yOffset = -100; // adjust offset if sticky header
 //        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

 //        window.scrollTo({
 //          top: y,
 //          behavior: 'smooth'
 //        });
 //      }
 //    });
 //  });
/***Build Price Images Slider***/
$(document).ready(function () {
    function initMobileSlider() {
      if ($(window).width() < 768) {
        if (!$('.cs-images-block').hasClass('slick-initialized')) {
          $('.cs-images-block').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000
            // dots: false,
            // arrows: false
          });
        }
      } else {
        if ($('.cs-images-block').hasClass('slick-initialized')) {
          $('.cs-images-block').slick('unslick');
        }
      }
    }

    // Run on load and resize
    initMobileSlider();
    $(window).on('resize', initMobileSlider);
  });


/****All Review Button****/
document.addEventListener("DOMContentLoaded", function () {
  const reviewBtn = document.querySelector('.see-all-reviews-btn');
  const scrollTarget = document.querySelector('#case-studies');

  if (reviewBtn && scrollTarget) {
    reviewBtn.addEventListener('click', function (e) {
      // No href = no need for preventDefault, but we can include it just in case
      e.preventDefault();
      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
});



document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ContactForm');

  if (form) {
    // Check if the URL contains 'contact_posted=true' (Shopify's success flag)
    const urlParams = new URLSearchParams(window.location.search);
    const formPosted = urlParams.get('contact_posted');

    if (formPosted === 'true') {
      window.location.href = '/pages/thank-you'; // 👈 change if your page URL is different
    }
  }
});